import { insforge, getIsStaging } from "./insforge";

/**
 * Thin wrapper around `insforge.database.from(table)` that automatically:
 *
 * - Injects `is_staging` (from the current build env) on every
 *   `insert()` / `upsert()` row so Preview writes never pollute Production.
 * - Adds `.eq("is_staging", ...)` to every `select()`, `update()` and
 *   `delete()` chain so a Preview bundle never reads Production rows
 *   (and vice versa).
 *
 * Every other builder method (`.eq`, `.order`, `.limit`, `.single`,
 * `.in`, `.gt`, `.ilike`, …) is untouched — the wrapper returns the
 * native SDK builder after the `is_staging` filter/payload has been
 * applied, so callers chain exactly as before.
 *
 * Tables in `UNSCOPED` bypass the wrapper entirely because they are managed
 * by InsForge auth and do not carry an `is_staging` column.
 */

const UNSCOPED = new Set(["profiles"]);

function tagRows(rows) {
  const flag = getIsStaging();
  const arr = Array.isArray(rows) ? rows : [rows];
  return arr.map((r) => ({ ...r, is_staging: flag }));
}

export function fromTable(name) {
  const base = insforge.database.from(name);
  if (UNSCOPED.has(name)) return base;

  return {
    select: (...args) => {
      const q = base.select(...args);
      return q.eq("is_staging", getIsStaging());
    },
    insert: (rows) => base.insert(tagRows(rows)),
    upsert: (rows, opts) =>
      opts !== undefined ? base.upsert(tagRows(rows), opts) : base.upsert(tagRows(rows)),
    update: (patch) => {
      const q = base.update(patch);
      return q.eq("is_staging", getIsStaging());
    },
    delete: () => {
      const q = base.delete();
      return q.eq("is_staging", getIsStaging());
    },
  };
}

